<template>
  <div class="app-container">
    <!-- 操作按钮区域 -->
    <div class="filter-container">
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
        新增
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column label="序号" type="index" width="60" align="center" />
      <el-table-column label="操作类型" prop="actionType" align="center" />
      <el-table-column label="创建工单类型ID" prop="createTicketTypeId" align="center" />
      <el-table-column label="创建类型" prop="createType" align="center" />
      <el-table-column label="创建子项" prop="createByChildren" align="center" />
      
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible"
               append-to-body>
      <el-form ref="dataForm" :model="temp" label-position="left" label-width="120px">
        <el-form-item label="操作类型">
          <el-select v-model="temp.actionType" placeholder="请选择操作类型">
            <el-option label="入库事件" value="inbound" />
            <el-option label="入库事件-bom" value="inbound-bom" />
            <el-option label="出库事件" value="outbound" />
            <el-option label="出库事件-bom" value="outbound-bom" />
            <el-option label="创建流程单" value="createTicket" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建工单类型">
          <el-select :disabled="temp.actionType !== 'createTicket'" clearable v-model="temp.createTicketTypeId" placeholder="请选择工单类型">
            <el-option
              v-for="item in ticketTypeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :disabled="temp.actionType !== 'createTicket'" label="创建类型">
          <el-select v-model="temp.createType" placeholder="请选择操作类型">
            <el-option label="物料" value="material" />
            <el-option label="账单" value="bill" />
            <el-option label="全部" value="all" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建子项">
          <el-checkbox :disabled="temp.actionType !== 'createTicket'" v-model="temp.createByChildren" true-label="Y" false-label="N"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'TicketAction',
  props: {
    typeId: {
      type: Number
    },
  },
  data() {
    return {
      list: [],
      listLoading: true,
      dialogFormVisible: false,
      dialogTitle: '',
      dialogStatus: '',
      temp: {
        id: undefined,
        action_type: null,
        create_ticket_type_id: null,
        create_type: null,
        create_by_children: "N"
      },
      // 新增工单类型选项数组
      ticketTypeOptions: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 获取数据列表
    fetchData() {
      this.listLoading = true
      console.log('this.typeId',this.typeId)
      requestTicket.post('/Ticketing/ticket-action/findAll')
        .then(response => {
          const _data = response.data
          this.list = _data.filter(item => item.typeId === this.typeId)
          this.listLoading = false
        })
    },
    
    // 重置表单数据
    resetTemp() {
      this.temp = {
        id: undefined,
        typeId: this.typeId,
        action_type: null,
        create_ticket_type_id: null,
        create_type: null,
        create_by_children: "N"
      }
    },
    
    // 新增方法：获取工单类型数据
    fetchTicketTypes() {
      requestTicket.post('/Ticketing/ticket-type/findAll')
        .then(response => {
          this.ticketTypeOptions = response.data || []
        })
    },

    // 打开新增对话框
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogTitle = '新增操作'
      this.dialogFormVisible = true
      // 新增：获取工单类型数据
      this.fetchTicketTypes()
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    
    // 打开编辑对话框
    handleUpdate(row) {
      this.temp = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogTitle = '编辑操作'
      this.dialogFormVisible = true
      // 新增：获取工单类型数据
      this.fetchTicketTypes()
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    
    // 新增数据
    createData() {
      this.temp.typeId = this.typeId
      requestTicket.post('/Ticketing/ticket-action/save', this.temp)
        .then(() => {
          this.dialogFormVisible = false
          this.$message.success('新增成功')
          this.fetchData()
        })
    },
    
    // 更新数据
    updateData() {
      this.temp.typeId = this.typeId
      requestTicket.post('/Ticketing/ticket-action/save', this.temp)
        .then(() => {
          this.dialogFormVisible = false
          this.$message.success('更新成功')
          this.fetchData()
        })
    },
    
    // 删除数据
    handleDelete(row) {
      this.$confirm('确认删除该记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        requestTicket.delete(`/Ticketing/ticket-action/${row.id}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchData()
          })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
</style>